module.exports = __webpack_public_path__ + "static/img/9.5bf5162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/eng/9.png
// module id = 6mih
// module chunks = 0